import { Input, Select } from "antd";
import { Plus, X } from "lucide-react";
import { nanoid } from "nanoid";
import {
  FLUENCY_OPTIONS,
  RESUME_SECTION_TYPES,
} from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";

const blankItem = () => ({
  id: `lang-${nanoid(6)}`,
  language: "",
  proficiency: "Fluent",
});

export default function Languages({
  id,
  data,
  onChange,
  onDelete,
  allCollapsed,
}) {
  const items = data ?? [];

  const updateItem = (idx, patch) => {
    onChange(items.map((it, i) => (i === idx ? { ...it, ...patch } : it)));
  };

  const removeItem = (idx) => {
    onChange(items.filter((_, i) => i !== idx));
  };

  const addItem = () => {
    onChange([...items, blankItem()]);
  };

  return (
    <SectionCardShell
      id={id}
      type={RESUME_SECTION_TYPES.LANGUAGES}
      data={data}
      onChange={onChange}
      onDelete={onDelete}
      allCollapsed={allCollapsed}
    >
      <div className="flex flex-col gap-3">
        {items.map((it, idx) => (
          <div key={it.id} className="flex gap-2 items-center">
            <Input
              placeholder="Language"
              value={it.language}
              onChange={(e) => updateItem(idx, { language: e.target.value })}
              style={{ flex: 1 }}
            />
            <Select
              value={it.proficiency}
              onChange={(val) => updateItem(idx, { proficiency: val })}
              options={FLUENCY_OPTIONS.map((f) => ({ value: f, label: f }))}
              style={{ width: 180 }}
            />
            <button
              onClick={() => removeItem(idx)}
              className="text-gray-400 hover:text-red-600"
            >
              <X size={16} />
            </button>
          </div>
        ))}
        <button
          onClick={addItem}
          className="self-start flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700"
        >
          <Plus size={14} /> Add language
        </button>
      </div>
    </SectionCardShell>
  );
}
